import React from 'react';
import ResultCard from './ResultCard';
import './ResultCardList.css';
import LinkoutIcon from './LinkoutIcon';

// Titles sometimes come back as a comma-joined list of duplicates/variants plus a site
// suffix (e.g. "Geronimo Stilton,Geronimo Stilton,Geronimo Stilton | KiKA") - only the
// first segment is the actual title we want to display.
const firstTitleSegment = (title) => title?.split(',')[0]?.trim() || '';

const ResultCardList = ({ items, title, originalQuery, intentSuggestions, onSuggestionClick }) => {
    return (
        <span className='card-list-container'>
            <div className="card-list-title kika-search">
                <div className="suggestion-label">{"Suchvorschläge:"}</div>
                {intentSuggestions?.intent_suggestions && intentSuggestions.intent_suggestions.length > 0 && (
                    <div className="suggestion-btn-row">
                        {intentSuggestions.intent_suggestions.map((suggestion, index) => (
                            <button
                                key={index}
                                className="suggestion-btn suggestion-btn"
                                onClick={() => onSuggestionClick?.(suggestion)}
                            >
                                {suggestion}
                            </button>
                        ))}
                    </div>
                )}
                <div style={{ marginTop: '24px' }}>{"Ergebnisse für: " + title}</div>
                <a href={"https://www.kika.de/suche/suche104?q=" + originalQuery} target="_blank" rel="noreferrer">
                    <LinkoutIcon />
                    <span> KIKA Treffer</span>
                </a>
            </div>
            <div className="card-list">
                {items.length === 0
                    ?
                    <div>Keine Treffer gefunden</div>
                    :
                    items.map((item, index) => (
                        <ResultCard
                            key={index}
                            image={item.teaser_image_url || '/stock-img.png'}
                            titleBroadcast={item.broadcast_series_title || ""}
                            title={firstTitleSegment(item.title)}
                            link={item.live_url}
                        />
                    ))
                }
            </div>
        </span>
    );
};
export default ResultCardList;
